import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global error handler to suppress errors from malicious browser extensions
window.addEventListener('error', (event) => {
  // Check if error is from suspicious domains
  const errorMessage = event.message || '';
  const errorSource = event.filename || '';
  
  if (
    errorMessage.includes('Failed to fetch') ||
    errorSource.includes('sevendata.fun') ||
    errorSource.includes('secdomcheck.online') ||
    errorMessage.includes('postUserData') ||
    errorMessage.includes('ERR_SSL_PROTOCOL_ERROR')
  ) {
    // Suppress errors from malicious browser extensions
    event.preventDefault();
    console.warn('Suppressed error from potentially malicious source:', errorSource || errorMessage);
    return false;
  }
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || event.reason?.toString() || '';
  
  if (
    errorMessage.includes('Failed to fetch') ||
    errorMessage.includes('sevendata.fun') ||
    errorMessage.includes('secdomcheck.online') ||
    errorMessage.includes('postUserData') ||
    errorMessage.includes('ERR_SSL_PROTOCOL_ERROR')
  ) {
    // Suppress promise rejections from malicious browser extensions
    event.preventDefault();
    console.warn('Suppressed unhandled rejection from potentially malicious source:', errorMessage);
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
